// extracted by mini-css-extract-plugin
export default {"container":"Suggestion_container__8sz+B"};